import BigNumber from "bignumber.js";

export const isElementVisible = (el) => {
  var rect = el.getBoundingClientRect(),
    vWidth = window.innerWidth || document.documentElement.clientWidth,
    vHeight = window.innerHeight || document.documentElement.clientHeight,
    efp = function (x, y) {
      return document.elementFromPoint(x, y);
    };

  // Return false if it's not in the viewport
  if (rect.right < 0 || rect.bottom < 0 || rect.left > vWidth || rect.top > vHeight) return false;

  // Return true if any of its four corners are visible
  return (
    el.contains(efp(rect.left, rect.top)) ||
    el.contains(efp(rect.right, rect.top)) ||
    el.contains(efp(rect.right, rect.bottom)) ||
    el.contains(efp(rect.left, rect.bottom))
  );
};

export function formatNumber() {
  Number.prototype.format = function (n, x, s, c) {
    var re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\D" : "$") + ")",
      num = this.toFixed(Math.max(0, ~~n));

    return (c ? num.replace(".", c) : num).replace(new RegExp(re, "g"), "$&" + (s || ","));
  };
}
export function formatNumberOnly(n) {
  if (Number(n) > 0) {
    return Number(n).toLocaleString();
  } else {
    return 0;
  }
}

export function convertAmountWithDecimals(value = 0, decimals = 18) {
  return new BigNumber(`${value}`).times(new BigNumber("10").pow(decimals));
}

export function convertAmountFromRawNumber(value = 0, decimals = 18) {
  return new BigNumber(`${value}`).dividedBy(new BigNumber("10").pow(decimals)).toFixed(decimals);
}

export function showBalanceWithSpanLayout(balances) {
  if (balances > 0) {
    var data = convertAmountFromRawNumber(balances.toString(), 18);

    var number_1 = Math.floor(data);
    var number_2 = balances - convertAmountWithDecimals(number_1, 18);
    number_2 = convertAmountFromRawNumber(number_2, 18);

    number_2 = String(number_2).replace("0.", ".");
    number_2 = String(number_2).replace("0,", ",");

    var txt = "<span>" + formatNumberOnly(number_1) + "</span>" + number_2;
    return txt;
  }

  return "<span>0</span>";
}

export function showBalanceWithSpanLayout2(balances) {
  if (balances > 0) {
    var data = convertAmountFromRawNumber(balances.toString(), 18);

    var number_1 = Math.floor(data);
    var number_2 = balances - convertAmountWithDecimals(number_1, 18);
    number_2 = convertAmountFromRawNumber(number_2, 18);

    number_2 = String(number_2).replace("0.", ".");
    number_2 = String(number_2).replace("0,", ",");

    var txt = formatNumberOnly(number_1) + "<span>" + number_2 + "</span>";
    return txt;
  }

  return "0<span>.0</span>";
}

export function saveDataTokenCreate(data) {
  localStorage.setItem("create-token", JSON.stringify(data));
}

export function getDataTokenCreate() {
  return JSON.parse(localStorage.getItem("create-token"))
    ? JSON.parse(localStorage.getItem("create-token"))
    : null;
}
export function ellipseAddress(address = "", width = 10) {
  return `${address.slice(0, width)}...${address.slice(-width)}`;
}
